import React, { useState } from 'react';
import { useQueryClient } from 'react-query';
import { useEffectOnce } from 'react-use';
import { Header } from './components/Header/Header';
import { Chart } from './components/Chart/Chart';
import { Wrapper } from '../../../../../../CommonComponents/OPL/Wrapper/Wrapper';
import { MarginProps } from '../../../../../../theme/styledProps';
import { Legend } from './components/Legend/Legend';
import { PDFTitle } from '../../../../../../PDFRenderer/components/PDFTitle/PDFTitle';
import { MarketScenarios } from '../../components/MarketScenarios/MarketScenarios';
import { MonteCarloTab } from './MonteCarlo.meta';
import { MonteCarloTabSection } from './components/MonteCarloTabSection/MonteCarloTabSection';
import { queryKeys } from '../../../../api/queryKeys';
import { useRouteParams } from '../../../../hooks/useRouteParams';
import { useFpId } from '../../../../../hooks/useFpId';

interface Props extends MarginProps {
  isPrint?: boolean;
  title?: string;
}

export const MonteCarlo = ({ isPrint, title, ...rest }: Props) => {
  const [activeView, setActiveView] = useState(MonteCarloTab.SummaryOfTrials);

  const queryClient = useQueryClient();
  const { clientId } = useRouteParams();
  const fpId = useFpId();

  useEffectOnce(() => {
    return () => {
      queryClient.removeQueries(queryKeys.monteCarlo(clientId, fpId));
      queryClient.removeQueries(queryKeys.marketScenarios(+clientId, fpId));
    };
  });

  if (isPrint) {
    return (
      <Wrapper {...rest}>
        <PDFTitle title={title} />
        <Header />
        <Chart mt="8" isPrint={isPrint} />
        <Legend isPrint={isPrint} />
      </Wrapper>
    );
  }

  return (
    <Wrapper {...rest}>
      <PDFTitle title={title} />

      <MonteCarloTabSection activeView={activeView} setActiveView={setActiveView} />

      {activeView === MonteCarloTab.SummaryOfTrials && (
        <>
          <Header />
          <Chart mt="8" isPrint={isPrint} />
          <Legend isPrint={isPrint} />
        </>
      )}

      {activeView === MonteCarloTab.MarketScenarios && <MarketScenarios />}
    </Wrapper>
  );
};
